import React from 'react';
import styled from 'styled-components';

const sameDaysOptions = [
  {
    value: '0',
    label: 'Каждый день новое меню',
  },
  {
    value: '2',
    label: 'По 2 одинаковых дня',
  },
  {
    value: '3',
    label: 'По 3 одинаковых дня',
  },
  {
    value: '4',
    label: 'По 4 одинаковых дня',
  },
  {
    value: '7',
    label: 'Всю неделю одинаковое меню',
  },
];

const TypeMenuBlock = ({
  sameDaysCount,
  setSameDaysCount,
  selectedDayCount, // optional
}) => {
  const handleChangeRadio = (e) => {
    setSameDaysCount(e.target.value);
  };
  return (
    <React.Fragment>
      <H3>Выберите количество повторяющихся дней</H3>

      <TypeMenusBlock>
        {sameDaysOptions.map((sameDaysOption) => {
          if (+sameDaysOption.value > 2 && +selectedDayCount === 2) return null;
          return (
            <RadioBlock key={sameDaysOption.label}>
              <RadioButton
                type="radio"
                id={`radio${sameDaysOption.value}`}
                value={sameDaysOption.value}
                name="typeGenerate"
                checked={sameDaysCount === sameDaysOption.value}
                onChange={handleChangeRadio}
              />
              <Label htmlFor={`radio${sameDaysOption.value}`}>{sameDaysOption.label}</Label>
            </RadioBlock>
          );
        })}
      </TypeMenusBlock>
    </React.Fragment>
  );
};

export default TypeMenuBlock;

const H3 = styled.h3`
  text-align: center;
  font-size: 20px;
  margin-top: 20px;
`;

const TypeMenusBlock = styled.div`
  margin: 0 auto;
  border: 1px solid #c1c1c1;
  background: #fff;
  border-radius: 5px;
  box-shadow: 3px 3px 2px #afafaf;
  padding: 5px 10px;
`;

const RadioBlock = styled.div`
  width: 300px;
  margin: 10px 0px;
`;

const RadioButton = styled.input`
  cursor: pointer;
  margin: 0px 5px 0px 0px;
`;

const Label = styled.label`
  cursor: pointer;
  font-size: 18px;
`;



// WEBPACK FOOTER //
// ./src/Components/Common/TypeMenuBlock.jsx